export default text => text.replace(/(\r\n|\n|\r)/gm, '<br />');
